import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { X, Check, TrendingDown, TrendingUp } from 'lucide-react';
const comparisons = [{
  sin: 'Perdido frente al ECG sin saber por dónde empezar',
  con: 'Método de 8 pasos aplicable en cualquier trazado en 2 minutos'
}, {
  sin: 'Sin saber qué droga pedir ni a qué dosis',
  con: 'Tabla de drogas plastificada en el bolsillo de la guardia'
}, {
  sin: 'Memorizás sin entender el razonamiento',
  con: '80+ algoritmos visuales que conectan teoría con práctica'
}, {
  sin: 'Sin casos clínicos para entrenar antes de guardia',
  con: '100 casos resueltos con razonamiento paso a paso'
}, {
  sin: 'Libros en inglés de 800 páginas que no leés',
  con: '6 tomos visuales en español rioplatense de 30 páginas cada uno'
}, {
  sin: 'Sin saber qué es urgente y qué puede esperar',
  con: 'Badges de CRÍTICO e IMPORTANTE en cada página'
}, {
  sin: 'Sin cheatsheets para consultar en el momento',
  con: '60 tarjetas imprimibles para llevar a cada guardia'
}, {
  sin: 'Cero diferenciación frente a tus compañeros',
  con: 'Razonamiento clínico que los residentes notan desde el primer día'
}];
export function ComparisonTable() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-16 px-4 bg-gray-50" ref={ref} data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        <div className="text-center mb-10" data-id="element-58">
          <div className="inline-block bg-gray-900 text-white font-bold px-4 py-1.5 rounded-full text-xs mb-4 tracking-widest" data-id="element-59">
            LA REALIDAD
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-gray-900 mb-2" data-id="element-60">
            ¿Cuánto cuesta <span className="text-urgency-red" data-id="element-61">NO</span> tenerlo?
          </h2>
        </div>

        {/* Headers as separate cards */}
        <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4" data-id="element-62">
          <div className="bg-urgency-red text-white rounded-2xl p-4 md:p-5 shadow-lg flex items-center justify-center gap-2" data-id="element-63">
            <TrendingDown size={20} data-id="element-64" />
            <h3 className="font-heading font-black text-sm md:text-xl" data-id="element-65">
              SIN EL ATLAS
            </h3>
          </div>
          <div className="bg-success-green text-white rounded-2xl p-4 md:p-5 shadow-lg flex items-center justify-center gap-2" data-id="element-66">
            <TrendingUp size={20} data-id="element-67" />
            <h3 className="font-heading font-black text-sm md:text-xl" data-id="element-68">
              CON EL ATLAS
            </h3>
          </div>
        </div>

        {/* Comparison rows */}
        <div className="space-y-3" data-id="element-69">
          {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-70">
              <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: i * 0.08
          }} className="bg-white rounded-xl p-3 md:p-4 border border-red-100 flex items-start gap-2 md:gap-3" data-id="element-71">
                <motion.div initial={{
              scale: 0
            }} animate={isInView ? {
              scale: 1
            } : {
              scale: 0
            }} transition={{
              delay: i * 0.08 + 0.2,
              type: 'spring'
            }} className="bg-red-50 rounded-full p-1 shrink-0" data-id="element-72">
                  <X size={14} className="text-urgency-red" strokeWidth={3} data-id="element-73" />
                </motion.div>
                <p className="text-xs md:text-sm text-gray-600 line-through decoration-red-300 decoration-1" data-id="element-74">
                  {item.sin}
                </p>
              </motion.div>

              <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: i * 0.08 + 0.1
          }} className="bg-green-50 rounded-xl p-3 md:p-4 border border-green-200 flex items-start gap-2 md:gap-3" data-id="element-75">
                <motion.div initial={{
              scale: 0
            }} animate={isInView ? {
              scale: 1
            } : {
              scale: 0
            }} transition={{
              delay: i * 0.08 + 0.3,
              type: 'spring'
            }} className="bg-success-green rounded-full p-1 shrink-0" data-id="element-76">
                  <Check size={14} className="text-white" strokeWidth={3} data-id="element-77" />
                </motion.div>
                <p className="text-xs md:text-sm text-gray-900 font-semibold" data-id="element-78">
                  {item.con}
                </p>
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}